import { FC } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { IUserPostRequest } from '../model/usersModel';
import Title from '../../../components/Title';
import TextField from '../../../components/form/elements/TextField';
import EntityForm from '../../../components/form/base/EntityForm';
import { TEXT_FIELD_TYPE, TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../../components/form/enum/formProps';

interface UsersFormProps {
  title: string;
  initialValues: IUserPostRequest;
  onSubmit: (values: IUserPostRequest) => void;
}

const schema = Yup.object().shape({
  username: Yup.string()
    .matches(/^[a-zA-Z0-9.@_-]+$/, 'validation.invalid_characters')
    .min(1, 'validation.too_short')
    .max(100, 'validation.too_long')
    .required('validation.is_required'),
});

const UsersForm: FC<UsersFormProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Title>{t(props.title)}</Title>
      <EntityForm<IUserPostRequest>
        initialValues={props.initialValues}
        validationSchema={schema}
        onSubmit={props.onSubmit}
      >
        <TextField
          name="username"
          label="users.admins.username"
          type={TEXT_FIELD_TYPE.TEXT}
          color={TEXT_FIELD_COLOR.PRIMARY}
          variant={TEXT_FIELD_VARIANT.STANDARD}
        />
      </EntityForm>
    </>
  );
};

export default UsersForm;
